export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shown:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["total"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Per page"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Results"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["of"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trade"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trades"])}
}